import { render, staticRenderFns } from "./BloodTypeCards.vue?vue&type=template&id=3576a797&"
import script from "./BloodTypeCards.vue?vue&type=script&lang=js&"
export * from "./BloodTypeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports